import { render, staticRenderFns } from "./geniusInfo.vue?vue&type=template&id=099c534b&scoped=true"
import script from "./geniusInfo.vue?vue&type=script&lang=js"
export * from "./geniusInfo.vue?vue&type=script&lang=js"
import style0 from "./geniusInfo.vue?vue&type=style&index=0&id=099c534b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c534b",
  null
  
)

export default component.exports